var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9895 14.1252C17.0438 12.6898 17.6666 10.9176 17.6666 9.00004C17.6666 4.21357 13.7864 0.333374 8.99992 0.333374C4.21345 0.333374 0.333252 4.21357 0.333252 9.00004C0.333252 13.7865 4.21345 17.6667 8.99992 17.6667C10.918 17.6667 12.6906 17.0436 14.1263 15.9887L14.1251 15.9896C14.1644 16.0429 14.2082 16.094 14.2565 16.1422L19.3904 21.2762C19.9111 21.7969 20.7554 21.7969 21.2761 21.2762C21.7968 20.7555 21.7968 19.9113 21.2761 19.3906L16.1421 14.2566C16.0938 14.2083 16.0428 14.1645 15.9895 14.1252ZM16.3333 9.00004C16.3333 13.0501 13.05 16.3334 8.99992 16.3334C4.94983 16.3334 1.66659 13.0501 1.66659 9.00004C1.66659 4.94995 4.94983 1.66671 8.99992 1.66671C13.05 1.66671 16.3333 4.94995 16.3333 9.00004Z",
    fill: "#7E8699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1b50e85ac383bd7d38cd2cb971cbf68a.svg";
export { ForwardRef as ReactComponent };